import React from 'react';
import '../css/button.css';

const ImageButton = (props) => {

    const classNameForButton = props.classNameForButton || "";
    const dirName = props.dirName;
    const id = props.id;
    const x = props.x;
    const y = props.y;
    const callback = props.callback || (() => { });

    return (<div>
        <img className={classNameForButton}
            src={process.env.PUBLIC_URL + "/assets/images/" + dirName + "/" + id + ".png"}
            alt="button"
            style={
                { position: "absolute", left: x, top: y, ...props.style, cursor: "pointer" }}
            onClick={callback}
            onMouseEnter={props.onMouseEnter}
            onMouseLeave={props.onMouseLeave}
        /> </div>
    );
}

export default ImageButton;